import { Form, Modal, Select, Image, Button, message } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import useStore from "@/pages/documentCompile/store/useStore";
import { useShallow } from "zustand/react/shallow";
import { getDictTableData } from "@/pages/documentCompile/dict/utils";
import { DictTemplateCodeEnum } from "@/pages/documentCompile/dict/type";
import useGlobalStore from "@/store/useGlobalStore";

interface Props {
    open: boolean
    onClose: () => void
    onOk: (values: any) => void
}

export default function SignModal(props: Props) {
    const [form] = Form.useForm();
    const [fileList, setFileList] = useState<any[]>([]);
    const [options, setOptions] = useState<any[]>([]);
    const setStoreState = useStore.setState
    const { signImageRes, signFormData } = useStore(
        useShallow(s => ({
            signImageRes: s.signImageRes,
            signFormData: s.signFormData
        })),
    )
    const handleFinish = (values: any) => {
        // const userInfo = useGlobalStore.getState().userInfo
        // const settingDomainFormData = useStore.getState().settingDomainFormData
        const newSettingDomainFormData = {}
        const signObj = {
            sign: values.sign,
            picFileKey: signImageRes.picFileKey,
            picFileUrl: signImageRes.picFileUrl,
        }
        // const fieldValue = { [values.sign]: sign }
        // console.log("signObj", signObj)
        if (values?.sign) {
            newSettingDomainFormData[values.sign] = signObj
        }
        // console.log("newSettingDomainFormData", newSettingDomainFormData)
        setStoreState({
            signFormData: newSettingDomainFormData,
        });
        // console.log("提交数据：", values);
        message.success("提交成功！");
        props.onOk(values);
    };

    const handleOk = () => {
        if (!signImageRes?.picFileUrl) {
            message.error("你未上传签名文件，请联系管理员上传个人签名文件！");
            return;
        }
        form.validateFields()
            .then(handleFinish)
            .catch((err) => {
                console.log("校验失败：", err);
            });
    };

    // const uploadProps = {
    //     beforeUpload: (file: any) => {
    //         // 不进行实际上传，只展示
    //         setFileList([file]);
    //         // 设置字段值
    //         form.setFieldsValue({ image: file });
    //         return false; // 阻止默认上传
    //     },
    //     fileList,
    //     onRemove: () => {
    //         setFileList([]);
    //         form.setFieldsValue({ image: null });
    //     }
    // };

    const fetchData = async () => {
        const resTable = await getDictTableData(DictTemplateCodeEnum.SIGN_ATTR)
        resTable.sort((a, b) => a.sort - b.sort)
        const options = []
        resTable.forEach(item => {
            const code = item?.extraAttrs[0]?.attrVals?.[0]?.key
            if (code && item.enable) {
                options.push({
                    label: item.dictName,
                    value: code
                })
            }
        })
        // const extraAttrs = resTable.map(i=>i.extraAttrs)?.flat()
        // const codeAttrs = extraAttrs.filter(i=>i.attrCode === 'sfcode')
        // const attrVals = codeAttrs.map(i=>i.attrVals)?.flat()
        if (options?.length > 0) {
            setOptions(options)
        }
    }

    useEffect(() => {
        if (props.open) {
            form.resetFields();
            fetchData()
        }
    }, [props.open,])

    useEffect(() => {
        if (signImageRes?.picFileUrl) {
            setFileList([signImageRes?.picFileUrl])
        }
    }, [signImageRes])

    useEffect(() => {
        const keys = Object.keys(signFormData || {})
        const formKey = keys[0]
        if (signFormData) {
            form.setFieldsValue({ 'sign': formKey })
        }
    }, [signFormData])

    return (
        <Modal
            open={props.open}
            onCancel={props.onClose}
            onOk={handleOk}
            title="签名上传"
        >
            <Form form={form}  >
                <Form.Item
                    name="image"
                    required={false}
                    label="签名图片"
                >
                    {/* <Upload {...uploadProps} listType="picture">
                        <Button icon={<UploadOutlined />}>点击上传</Button>
                    </Upload> */}
                    <div style={{ width: '80px', height: 'auto', backgroundColor: '#f0f0f0' }}>
                        {/* <img src={signImageRes?.picFileUrl} alt="签名图片" style={{ width: '100%', height: '100%' }} /> */}
                        <Image
                            width={200}
                            src={signImageRes?.picFileUrl}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    name="sign"
                    label="签名"
                    rules={[{ required: true, message: '请选择签名' }]}
                >
                    <Select placeholder="请选择一个签名" options={options}>
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    );
}
